import Rails from '@rails/ujs'
import { debounce } from 'lodash-es'
import ApplicationController from './application_controller'
import consumer from '../channels/consumer'
import CableReady from 'cable_ready'
import Dropzone from "dropzone";

let connectionStatus
let currentRoomChannel
const reload = (controller, participant_id) => {
    controller._showLoadingIndicator()
    controller.stimulate('ChatReflex#reload', participant_id, controller._filter_closed_conversations() )
}
const debouncedReload = debounce(reload, 100)

const adminReload = (controller, participant_id) => {
    controller.stimulate('ChatReflex#adminReload', participant_id, controller._filter_closed_conversations() )
}
const debouncedAdminReload = debounce(adminReload, 100)


export default class extends ApplicationController {
    static targets = ['list', 'input', 'participant', 'room', 'messageattachment', 'presetmessage', 'conversationClosed', 'currentUserType', 'list', 'scrollBtn']
    static values = { refreshConversationlistInterval: Number }

    teardown() {
        // Teardown is called from index.js controller on TurboLinks reload
        this._unsubscribeCurrentRoom();
        if (this.refreshConversationsTimer) {
            clearInterval(this.refreshConversationsTimer);
        }
    }

    initialize() {
        // Access Stimulus controller instances
        // https://docs.stimulusreflex.com/rtfm/patterns
        this.element[this.identifier] = this

        const usersListCollapsed = localStorage.getItem('usersListCollapsed') === 'true';
        if (usersListCollapsed) {
            const usersListContainer = document.querySelector('.users-list-container');
            const toggleButton = document.querySelector('#toggle-users-list i');

            if (usersListContainer && toggleButton) {
                usersListContainer.classList.remove('show-users-list');
                usersListContainer.classList.add('hide-users-list');
                toggleButton.classList.remove('fa-chevron-up');
                toggleButton.classList.add('fa-chevron-down');
            }
        }

        if (this.hasListTarget && this.hasScrollBtnTarget) {
            this.checkScrollPosition();
        }


        // We need to know when there are new messages that have been created by the other party
        // so we subscribe to the selected conversations's generated room ID
        // When no conversations are selected, there's no room, so we skip subscribing to room
        if (this.hasRoomTarget) { // Check if the room target exists
            this._subscribeToRoomChannel(this.roomTarget.value);
        }
        // if (this.roomTarget.value) {
        //     this._subscribeToRoomChannel(this.roomTarget.value)
        // }
        this.scroll(1)

        connectionStatus = true;

        document.addEventListener('stimulus-reflex:disconnected', this._disconnectedHandler);
        document.addEventListener('stimulus-reflex:connected', this._connectedHandler);
        document.addEventListener('chat:mark_received_messages_as_read', e => {
            // if window is in focus and we're chatting with the same recipient who sent us a message, mark messages from them as read
            if ((e.detail.fromParticipant === this.participantTarget.value) || (baseTitle == window.document.title)) {
                this.stimulate(
                    'ChatReflex#mark_messages_from_sender_as_read',
                    e.detail.fromParticipant
                )
            }
        });
        document.addEventListener('chat:hide_loading_indicator', () => {
            this._hideLoadingIndicator();
        });
        // Ensure we don't register multiple listeners across reconnects/morphs
        if (!this._refreshSidebarHandler) {
            this._refreshSidebarHandler = (e) => {
                // Backend notifies us that sidebar needs refreshing (new message, conversation update, etc.)
                console.log('chat:refresh_sidebar event received', e.detail);
                this._refreshConversationList();
            };
        }
        document.removeEventListener('chat:refresh_sidebar', this._refreshSidebarHandler);
        document.addEventListener('chat:refresh_sidebar', this._refreshSidebarHandler);

        if (this.data.get("refreshConversationlistIntervalValue")) {
            this._startRefreshingConversationList();
        }
    }

    disconnect() {
        // Clean up global listeners when controller disconnects to avoid duplicates
        if (this._refreshSidebarHandler) {
            document.removeEventListener('chat:refresh_sidebar', this._refreshSidebarHandler);
        }
    }

    _startRefreshingConversationList() {
        // console.log("Will start refreshing user list");
        this.refreshConversationsTimer = setInterval(() => {
            this._refreshConversationList()
        }, this.data.get("refreshConversationlistIntervalValue"))
    }

    _refreshConversationList() {
        this.stimulate('ChatReflex#reloadConversationsList',
        this._filter_closed_conversations(),
        $('.participant-data').first()[0].dataset['reloadType']
        )
    }

    _disconnectedHandler() {
        connectionStatus = false;
        setTimeout(() => {
            // delay disconnected notification to prevent it showing up on page reloads etc
            if (!connectionStatus) {
                jQuery("#chat-disconnect-notification").removeClass("notification-hidden");
                jQuery("#chatSubmitBtn").addClass("disabled");
            }
        }, 3000);
    }

    _connectedHandler() {
        connectionStatus = true;
        jQuery("#chat-disconnect-notification").addClass("notification-hidden");
        jQuery("#chatSubmitBtn").removeClass("disabled");
    }

    resubscribeToRoomChannelIfNeeded() {
        if (this.hasRoomTarget) { // Check if the room target exists
            try {
                const room_name = JSON.parse(currentRoomChannel.identifier).room;
                // room_Guest-1746_Conversation-1784
                if (room_name.includes(this.roomTarget.value)) {
                    return;
                } else {
                    this._resubscribeToRoomChannel();
                }
            } catch (e) {
                console.log("Could not resubscribe to room channel");
                console.log(e);
            }
        }
    }
    _resubscribeToRoomChannel() {
        if (this.hasRoomTarget) { // Check if the room target exists
            this._subscribeToRoomChannel(this.roomTarget.value);
        }
    }

    _unsubscribeCurrentRoom() {
        if (currentRoomChannel && currentRoomChannel.unsubscribe) currentRoomChannel.unsubscribe();
    }

    _subscribeToRoomChannel(room) {
        this._unsubscribeCurrentRoom();
        currentRoomChannel = consumer.subscriptions.create({ channel: "ChatChannel", room: 'room_' + room }, {
            received(data) {
                if (data.cableReady) CableReady.perform(data.operations)
            }
        });
    }

    handleKeydown(event) {
        // Check if Shift+Enter or on a Mac, Cmd+Enter is pressed
        if (event.shiftKey && event.key === 'Enter' || (event.metaKey && event.key === 'Enter')) {
            event.preventDefault();
            this.post(event);
        }
    }

    post(event) {
        Rails.stopEverything(event)

        // if the user if offline, we'll disable sending to prevent messages going out into the void
        if (!connectionStatus) return;
        var noteValue = this.getNoteValue();

        // also don't post anything if there's no message or no room
        let messageBody = this.inputTarget.value.trim();
        if (!messageBody || !this.roomTarget.value) {
            this.inputTarget.focus()
            return
        }

        // Admins can't send messages to closed conversations; this is possibly a workaround
        // as Guests CAN technically send messages to closed conversations, but we open a new conversation
        // if they try to send a message to a closed conversation
        if (this.conversationClosedTarget.value == "true" && this.currentUserTypeTarget.value == 'Admin') {
            this.inputTarget.focus()
            return
        }

        // Add a temporary placeholder message to the UI immediately
        this._addTemporaryMessage(messageBody);

        this.stimulate(
            'ChatReflex#post',
            this.participantTarget.value,
            messageBody,
            this.messageattachmentTarget.value,
            noteValue,
            null,
            this._filter_closed_conversations()
        ).then(() => {
            this.resubscribeToRoomChannelIfNeeded();
        });


        this.inputTarget.value = ''
        this.inputTarget.focus()
        $('#chatSubmitBtn').prop("disabled", true);
        $('#chatSubmitBtn').text('Sending...');
        setTimeout(() => {
            // delay disconnected notification to prevent it showing up on page reloads etc
            $('#chatSubmitBtn').prop("disabled", false);
            $('#chatSubmitBtn').text('Send');
        }, 3000);
        this.stimulate('ChatReflex#setMessageAttachment')
        this.scroll(1)
    }

    finalizePost() {
        console.log("afterPost");
    }

    attachAppServicesLink(event) {
        Rails.stopEverything(event)

        // if the user if offline, we'll disable sending to prevent messages going out into the void
        if (!connectionStatus) return;

        this.stimulate(
            'ChatReflex#attachAppServicesLink'
        )
    }

    afterAttachAppServicesLink () {
        $('#full-modal').modal('show');
    }

    attachWebsiteLink(event) {
        Rails.stopEverything(event)

        // if the user if offline, we'll disable sending to prevent messages going out into the void
        if (!connectionStatus) return;

        this.stimulate(
            'ChatReflex#attachWebsiteLink',
        )
    }

    afterAttachWebsiteLink() {
        $('#full-modal').modal('show');
    }

    usePresetMessage(event) {
        Rails.stopEverything(event)

        // if the user if offline, we'll disable sending to prevent messages going out into the void
        if (!connectionStatus) return;

        this.stimulate(
            'ChatReflex#usePresetMessage',
        )
    }

    afterUsePresetMessage() {
        $('#full-modal').modal('show');

        $('#TaskForm #app-content-list input').on('change', function (e) {
            $('#TaskForm #additional_comments').show();
            $('#TaskForm #TaskSubmit').show();
        });

        $('#TaskForm #show_attachments_link').on('click', function (e) {
            e.preventDefault();
            $('#TaskForm #show_attachments_link').hide();
            $('#TaskForm #attachments').show();
        });

        $('#TaskForm #SubmitTask').on('click', function (e) {
            $('#TaskForm #SubmitTask').prop("disabled", true);
            document.getElementById('chatController').chat.performFillPresetMessage($('#participant-to-send-to').val(), serialize_form_to_object($('#TaskForm')));
        });
    }


    performFillPresetMessage(participant, e) {
        Rails.stopEverything(event)

        // if the user if offline, we'll disable sending to prevent messages going out into the void
        if (!connectionStatus) return;

        const preset_message = e

        if (!preset_message) return;
        this.stimulate(
            'ChatReflex#setPresetMessage',
            participant,
            preset_message
        ).then(promise => {
            $('#TaskForm #SubmitTask').prop("disabled", false);
            $('#full-modal').modal('hide');
        })
    }

    attachImage(event) {
        Rails.stopEverything(event)

        // if the user if offline, we'll disable sending to prevent messages going out into the void
        if (!connectionStatus) return;

        this.stimulate(
            'ChatReflex#attachImage',
        )
    }

    getNoteValue() {
        var note = $('#NoteDropdown').val();
        return note === '' ? null : note;
    }

    afterAttachImage() {
        $('#full-modal').modal('show');
        $("#feature_image").parent().trigger("click");
    }

    afterSetMessageAttachmentImage() {
        $('#full-modal').modal('hide');
        $('#ImageSubmit').prop("disabled", false);
        $('#ImageSubmit').text('Add image');
    }

    attachCameraImage(event) {
        Rails.stopEverything(event)

        // if the user if offline, we'll disable sending to prevent messages going out into the void
        if (!connectionStatus) return;
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            navigator.mediaDevices.getUserMedia({video: true}).then((stream) => {
                this.stimulate(
                    'ChatReflex#attachCameraImage',
                )
            })
                .catch((error) => {
                    $("#errorMessage").text('Got error :', error)
                })
        } else {
            this.stimulate(
                'ChatReflex#attachImage',
            )
        }
    }

    afterAttachCameraImage() {
        $('#full-modal').modal('show');
        $("#feature_image").parent().trigger("click");
    }

    addParticipants (event) {
        Rails.stopEverything(event)

        // if the user if offline, we'll disable sending to prevent messages going out into the void
        if (!connectionStatus) return;

        this.stimulate(
            'ChatReflex#addParticipants',
            $('#participant-to-send-to').val()
        )
    }

    afterAddParticipants () {
        $('#full-modal').modal('show');

        $('#ParticipantForm #app-content-list input').on('change', function (e) {
            $('#ParticipantForm #ParticipantSubmit').show();
        });
    }

    performAddParticipants(e) {
        Rails.stopEverything(e)
        var conversation = $('#participant-to-send-to').val();
        if (!conversation) return;
        var participants = serialize_form_to_object($('#ParticipantForm'));
        if (!participants) return;
        $('#full-modal').modal('hide');

        this.stimulate('ChatReflex#setParticipants',
            conversation,
            participants
        )
        $('#full-modal').modal('hide');
    }

    attachAppServiceCategoryLink(event) {
        Rails.stopEverything(event)

        // if the user if offline, we'll disable sending to prevent messages going out into the void
        if (!connectionStatus) return;

        this.stimulate(
            'ChatReflex#attachAppServiceCategoryLink'
        )
    }

    afterAttachAppServiceCategoryLink() {
        $('#full-modal').modal('show');
    }


    performAttachAppLink(e) {
        var message_attachment = e
        if (!message_attachment) return;

        this.stimulate('ChatReflex#setMessageAttachment',
            message_attachment,
            this.getNoteValue()
        )
        $('#full-modal').modal('hide');
    }

    performAttachImage(e) {
        const message_attachment = e

        if (!message_attachment) return;

        this.stimulate('ChatReflex#setMessageAttachmentImage',
            message_attachment,
            this.getNoteValue()
        )
        $('#ImageSubmit').prop("disabled", true);
        $('#ImageSubmit').text('Adding images...');
    }

    validateWebsiteLink(e) {
        var message_attachment = e
        if (typeof e == 'string') {
            message_attachment = JSON.parse(e)
        };

        if (!message_attachment) return;

        this.stimulate('ChatReflex#validateWebsiteLink',
            message_attachment
        )
        $('#full-modal').modal('hide');
    }

    checkForMediaPermissions

    clearAttachment() {
        this.stimulate('ChatReflex#setMessageAttachment',
            null,
            this.getNoteValue()
        )
    }

    afterReload() {
        this.scroll(1)
        $('[data-toggle="tooltip"]').tooltip();

    }

    afterReflex() {
        var value = $('#NoteDropdown').val();
        if (value === 'Note') {
            $('#dropdownMenuMessage').html('Note<span class="caret"></span>');
            $("#chatSubmitBtn").text("Add Note");
            $("#chatInput").css({"background-color": "blanchedalmond"});
        } else {
            $('#dropdownMenuMessage').html('Reply<span class="caret"></span>');
            $("#chatSubmitBtn").text("Send Message");
            $("#chatInput").css({"background-color": "#fff"});
        }
    }

    select_chat_participant(event) {
        const dataElement = $(event.target).closest('div.participant-data')
        const participantElement = event.currentTarget;
        const avatarElement = participantElement.querySelector('.avatar-circle-sm');
        if (avatarElement) {
            const initialsElement = avatarElement.querySelector('.initials');

            if (initialsElement) {
                // Set the unread count to 0
                initialsElement.textContent = '0';

                // Update the title attribute
                const translatedUnreadText = avatarElement.title.split(' ').slice(1).join(' ');
                avatarElement.title = `0 ${translatedUnreadText}`;

                // Change the label class
                avatarElement.classList.remove('label-confirmed');
                avatarElement.classList.add('label-info');
            }
        }
        // Check IE10 support for dataset
        // jQuery .data() did not work correctly when user list was updated through a morph
        const room_id = dataElement[0].dataset['room']
        const participant_id = dataElement[0].dataset['participantId']
        const reload_type = dataElement[0].dataset['reloadType']
        const closed_filter = dataElement[0].dataset['closedFilter']
        // console.log("Will subscribe to room", room_id)
        this._subscribeToRoomChannel(room_id)
        this._reload(participant_id, reload_type)
        $("#admin_actions_container").removeClass("hidden");
    }


    delayedReloadConversationList() {
        const dataElement = $('.participant-data').first()[0]
        const reloadType = dataElement.dataset['reloadType']
        this._showLoadingIndicator()
        setTimeout(() => {
            this._reloadConversationList(reloadType)
        }, 300);
    }

    _reloadConversationList(reload_type) {
        this.stimulate('ChatReflex#reloadConversationsList',
        this._filter_closed_conversations(),
        reload_type
        )
    }

    afterreloadConversationsListMethod() {
        setTimeout(() => {
            this._hideLoadingIndicator()
        }, 300);
    }

    toggleMuteConversation(event) {
        Rails.stopEverything(event)
        const dataElement = $(event.target.parentNode)
        const convo = dataElement[0].dataset['convoId']
        if (!convo) return;

        this.stimulate('ChatReflex#toggleMuteConversation',
            convo
        )
    }

    toggleUsersList() {
        const usersListContainer = document.querySelector('.users-list-container');
        const toggleButton = document.querySelector('#toggle-users-list i');

        if (usersListContainer.classList.contains('show-users-list')) {
            usersListContainer.classList.remove('show-users-list');
            usersListContainer.classList.add('hide-users-list');
            toggleButton.classList.remove('fa-chevron-up');
            toggleButton.classList.add('fa-chevron-down');
        } else {
            usersListContainer.classList.add('show-users-list');
            usersListContainer.classList.remove('hide-users-list');
            toggleButton.classList.add('fa-chevron-up');
            toggleButton.classList.remove('fa-chevron-down');
        }
    }

    toggleCloseConversation(event) {
        Rails.stopEverything(event)
        if (confirm('Are you sure you want to close this conversation? This will archive the conversation, the guest will see all conversations they are involved in as one continuous conversation, but admins will only see the current conversation')) {
            const convo = $('#participant-to-send-to').val()
            if (!convo) return;
            // This is to prevent reloading the conversation list with a query present (?chat_participant_id=Guest-1709) when
            // an admin closes a conversation, thus reloading the conversation list and reopening the conversation
            const newUrl = window.location.pathname;
            if (window.history.replaceState) {
                window.history.replaceState({}, null, newUrl);
            } else {
                window.history.pushState({}, null, newUrl);
            }
            this.stimulate('ChatReflex#toggleCloseConversation',
                convo,
                this._filter_closed_conversations()
            )
        };
    }

    scroll(delay = 10) {
        const lists = document.querySelectorAll('[data-target="chat.list"]')
        setTimeout(() => {
            lists.forEach(e => {
                e.scrollTop = e.scrollHeight
                if (this.hasScrollBtnTarget) {
                    this.checkScrollPosition()
                }
            })
        }, delay)
    }

    scrollToLatest() {
        this.scroll(0)
    }

    checkScrollPosition() {
        if (!this.hasListTarget || !this.hasScrollBtnTarget) return;

        const chatHistory = this.listTarget;
        const button = this.scrollBtnTarget;

        // Check if we're near the bottom (within 100px of the bottom)
        const isNearBottom = chatHistory.scrollHeight - chatHistory.scrollTop - chatHistory.clientHeight < 100;

        // Show button only if we're not near the bottom
        if (isNearBottom) {
            button.classList.add('hidden');
        } else {
            button.classList.remove('hidden');
        }
    }

    _reload (participant_id, reload_type) {
        // console.log("will reload with participant...", participant_id)
        reload_type == "guest" ? debouncedReload(this, participant_id) : debouncedAdminReload(this, participant_id)
    }

    _filter_closed_conversations() {
        const activeLabel = document.querySelector('.btn-group .filter-button.active');
        const filter_elem = activeLabel ? activeLabel.querySelector('input[type="radio"]') : null;
        if (!filter_elem) return 'false';
        return filter_elem.value
    }

    _hideLoadingIndicator() {
        $('#UsersList').removeClass("totalDisabled");
        $('#PlaceHoldersList').addClass("totalDisabled");
        $('.filter-button').removeClass("totalDisabled");
        // $(".chat-list-container").removeClass("totalDisabled");
        // $("#message_input").removeClass("totalDisabled");

    }

    _showLoadingIndicator() {
        $('#UsersList').addClass("totalDisabled");
        $('.filter-button').addClass("totalDisabled");
        $('#PlaceHoldersList').removeClass("totalDisabled");
        //$(".chat-list-container").addClass("totalDisabled");
        // $("#message_input").addClass("totalDisabled");
    }

    _addTemporaryMessage(messageBody) {
        // Find the chat history container
        const chatHistory = this.listTarget;
        if (!chatHistory) return;

        // Get the current user name directly from the data attribute on the container
        const container = chatHistory.closest('.chat-list-container');
        const userName = container.dataset.userName || 'You';

        // Check if this is an internal note
        const noteValue = this.getNoteValue();
        const messageClass = noteValue ? 'internal-other-message' : 'other-message';

        // Create temporary message element with a special class
        const tempMessageHTML = `
        <li class="clearfix admin-message-container temp-message">
            <div class="message-data align-right">
                <span class="message-data-time"><em>Sending...</em></span>
                <span class="message-data-name">${userName}</span>
            </div>
            <div class="message float-right ${messageClass}">
                ${messageBody}
            </div>
        </li>
        `;

        // Add to the chat list
        chatHistory.querySelector('ul').insertAdjacentHTML('beforeend', tempMessageHTML);

        // Scroll to the new message
        this.scroll(1);
    }

    // Add this method to your existing chat_controller.js
    scrollToLatest() {
        this.scroll(0) // Use 0 delay for immediate scrolling
    }

}
